export const environment = {
  production: false,
  apiUrl: 'https://api-prerelease.smartprogressions.com'
};
